function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(255, 255, 255)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {'smoked': 'rgb(154, 86, 48)','natural': 'rgb(249, 247, 216)','midnight': 'rgb(7, 0, 0)','tan': 'rgb(225, 214, 170)','chocolate': 'rgb(108, 58, 30)','walnut': 'rgb(92, 85, 98)','rustic-pine': 'rgb(42, 69, 49)','blueberry': 'rgb(0, 91, 211)','midnight-navy': 'rgb(49, 44, 119)','midnight-warm-brown': 'rgb(127, 60, 21)','midnight-natural': 'rgb(234, 216, 171)','midnight-smoked': 'rgb(154, 86, 48)','warm-brown': 'rgb(154, 86, 48)','butternut-warm-brown': 'rgb(112, 61, 31)','tea-rose-and-grey': 'rgb(237, 191, 191)','rouge': 'rgb(240, 10, 10)','blue-moon': 'rgb(0, 91, 211)','lemon-sorbet': 'rgb(255, 229, 0)','pink-lemonade': 'rgb(255, 192, 203)','royal-blue-tigerlily': 'rgb(0, 91, 211)','natural-navy': 'rgb(59, 74, 115)','smoked-navy': 'rgb(39, 49, 79)','natural-sumac': 'rgb(168, 69, 47)','smoked-sumac': 'rgb(122, 46, 30)','natural-hunter': 'rgb(63, 90, 60)','smoked-hunter': 'rgb(43, 62, 40)','kelly-green-vintage-blue': 'rgb(5, 170, 61)','navy-french-blue': 'rgb(40, 32, 153)','chartreuse-golden-yellow': 'rgb(212, 154, 6)','blue-brown': 'rgb(0, 91, 211)','pink-red': 'rgb(255, 192, 203)','black-natural': 'rgb(0, 0, 0)','maroon-red': 'rgb(246, 31, 31)','maroon-yellow': 'rgb(255, 229, 0)','maroon-golden-yellow': 'rgb(212, 154, 6)','kate': 'rgb(120, 221, 125)','sprinkles': 'rgb(221, 157, 174)','vanilla-lavender': 'rgb(214, 183, 220)','quartz-butternut': 'rgb(193, 125, 73)','spumoni': 'rgb(255, 192, 203)','black-raspberry': 'rgb(0, 0, 0)','good-day': 'rgb(237, 12, 12)','black-raspberry': 'rgb(0, 0, 0)','butternut-quartz': 'rgb(183, 106, 87)','spumoni': 'rgb(255, 192, 203)','buoy': 'rgb(65, 129, 73)','blueberry-syrup': 'rgb(0, 91, 211)','cole-farms': 'rgb(193, 98, 89)','lobster-basket': 'rgb(237, 70, 70)','roadside-lupine': 'rgb(80, 57, 105)','royal-pine': 'rgb(104, 151, 68)','dungaree-lee': 'rgb(48, 67, 105)','camp-tote': 'rgb(198, 196, 91)','pleasant-mountain': 'rgb(49, 110, 63)','red-natural': 'rgb(246, 31, 31)','ma-cherie': 'rgb(247, 9, 9)','walnut-natural': 'rgb(131, 47, 47)','blue-wheel-white-flower': 'rgb(0, 91, 211)','white-wheel-pink-flower': 'rgb(244, 164, 208)','sunflower-yellow-wheel': 'rgb(247, 198, 24)','hunter-green': 'rgb(71, 113, 76)','evergreen': 'rgb(23, 84, 56)','natural-and-french-blue': 'rgb(117, 146, 184)','midnight-and-french-blue': 'rgb(27, 68, 121)',};

    this.images = {};

    this.triggers = ['color','colour','couleur','farbe','cor',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

window.theme.swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  window.theme.swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);
